export enum BusinessStructureEnum {
  LLC = 'LLC',
  S_CORP = 'SCORP',
  C_CORP = 'CCORP',
  SOLE_PROPRIETORSHIP = 'SOLEPROPRIETORSHIP',
  PARTNERSHIP = 'PARTNERSHIP',
  NON_PROFIT = 'NONPROFIT',
}

export const BusinessStructureLabels: Record<BusinessStructureEnum, string> = {
  [BusinessStructureEnum.C_CORP]: 'C Corp',
  [BusinessStructureEnum.S_CORP]: 'S Corp',
  [BusinessStructureEnum.LLC]: 'LLC',
  [BusinessStructureEnum.SOLE_PROPRIETORSHIP]: 'Sole Proprietorship',
  [BusinessStructureEnum.PARTNERSHIP]: 'Partnership',
  [BusinessStructureEnum.NON_PROFIT]: 'Non-Profit',
}
